import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoundService {

  private currentAudio?: HTMLAudioElement

  play(sound: string) {
    if (this.currentAudio) {
      this.currentAudio.pause()
      this.currentAudio.currentTime = 0
    }

    this.currentAudio = new Audio(sound)
    this.currentAudio.play().finally(() => this.currentAudio = undefined)
  }
}
